import React, { FC } from 'react';
import { useWatch } from 'react-hook-form';

import { CollectionFile, ComponentFileType, FileVisibility } from 'models';

import { DatasheetMode, useDatasheetMode } from 'components/datasheet/DatasheetMode';
import { FileGrid } from 'components/files/FileGrid';

import { ComponentDatasheetSection } from './ComponentDatasheetSection';

const Certificates: FC = () => {
    const mode = useDatasheetMode();

    const [files = []] = useWatch({ name: ['files'] }) as [CollectionFile[] | undefined];
    const certificates = files.filter(
        (file) => file.type === ComponentFileType.CERTIFICATE && file.visibility !== FileVisibility.PRIVATE,
    );

    if (mode !== DatasheetMode.VIEW || certificates.length === 0) return null;

    return (
        <ComponentDatasheetSection title="Certificates">
            <FileGrid files={certificates} />
        </ComponentDatasheetSection>
    );
};

export { Certificates };
